import { documentActionPanelOpenState } from '../../atoms/layout';
import PanelContainer from '../common/PanelContainer';
import UplaodButton from '../common/UploadButton';

interface Props {
  className?: string;
  attachmentId: string;
  records?: {
    createdAt: string;
    creator: string;
    id: string;
    state: string;
  }[];
}

export default function AttachmentActionsPanel({ attachmentId, records, className }: Props) {
  return (
    <PanelContainer
      heightState={documentActionPanelOpenState}
      resizeButton
      title="عملیات"
      className={className}
    >
      <UplaodButton attachmentId={attachmentId} />
    </PanelContainer>
  );
}
